import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Section } from 'components/layout'

export default class Form extends Component {
  static propTypes = {
    children: PropTypes.any.isRequired,
    contentLoader: PropTypes.node,
    onSubmit: PropTypes.func,
    encType: PropTypes.string,
    loading: PropTypes.bool
  }
  static defaultProps = {
    itemsCount: 4,
    withImage: false,
    loading: false,
    contentLoader: null,
    encType: 'application/x-www-form-urlencoded'
  }

  render() {
    const {
      loading,
      children,
      encType,
      onSubmit,
      contentLoader
    } = this.props

    return (
      <Section loading={loading} contentLoader={contentLoader}>
        <form onSubmit={onSubmit} encType={encType}>
          {children}
        </form>
      </Section>
    )
  }
}
